import React from 'react';
import LegalLayout from './LegalLayout';

const Privacy = () => (
  <LegalLayout
    eyebrow="Legal"
    title="Privacy Policy"
    lead="How this website handles the information you share. Plain language, no surprises."
  >
    <p className="legal-meta">Last updated: 3 June 2026</p>

    <h2>Who I am</h2>
    <p>
      This website (isurugimhan.com) is run by Isuru Gimhan, a freelance designer and developer
      based in Kalutara, Sri Lanka. For anything in this policy, you can reach me at{' '}
      <a href="mailto:contact@isurugimhan.com">contact@isurugimhan.com</a>. For the purposes of
      data-protection law, I am the controller of the personal data described below.
    </p>

    <h2>What I collect</h2>
    <p>I only collect what you choose to send me. In practice that means:</p>
    <ul>
      <li>
        <strong>Contact form details</strong> — the name, email address and message you submit
        through the contact form.
      </li>
      <li>
        <strong>Basic server logs</strong> — like most websites, my hosting provider may
        automatically record technical data such as your IP address, browser type and the time of
        your visit, for security and to keep the site running.
      </li>
    </ul>
    <p>
      I do <strong>not</strong> run advertising or analytics trackers, and I do not build profiles
      of visitors.
    </p>

    <h2>Why I use it</h2>
    <ul>
      <li>To read your message and reply to your enquiry.</li>
      <li>To discuss any work you'd like to talk about.</li>
      <li>To keep the website secure and functioning.</li>
    </ul>
    <p>
      I rely on your consent (when you submit the form) and my legitimate interest in responding to
      enquiries. I never sell your data.
    </p>

    <h2>Google Fonts</h2>
    <p>
      This site loads fonts from Google Fonts. When a page loads, your browser requests the fonts
      from Google's servers, which means your IP address is transmitted to Google. I don't control
      what Google does with that request — see{' '}
      <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">
        Google's privacy policy
      </a>{' '}
      for details.
    </p>

    <h2>Where your data goes</h2>
    <p>
      Contact-form messages are emailed to me and stored in my mailbox so I can reply. The website
      and email are hosted with my hosting provider. I don't share your information with anyone else
      except where I'm legally required to, or where a trusted provider (such as my host) processes
      it on my behalf to deliver the service.
    </p>

    <h2>How long I keep it</h2>
    <p>
      I keep enquiry messages only as long as needed to handle your request and for a reasonable
      period afterwards in case you follow up. If you'd like me to delete your message, just ask.
    </p>

    <h2>Your rights</h2>
    <p>
      Depending on where you live — including under the EU/UK GDPR and Sri Lanka's Personal Data
      Protection Act No. 9 of 2022 — you may have the right to access the personal data I hold about
      you, correct it, delete it, or object to how I use it. To exercise any of these, email{' '}
      <a href="mailto:contact@isurugimhan.com">contact@isurugimhan.com</a> and I'll respond as
      quickly as I can.
    </p>

    <h2>Children</h2>
    <p>This site is not directed at children, and I don't knowingly collect their data.</p>

    <h2>Changes to this policy</h2>
    <p>
      I may update this policy from time to time. When I do, I'll change the "last updated" date
      above.
    </p>

    <h2>Contact</h2>
    <p>
      Questions about your privacy? Email{' '}
      <a href="mailto:contact@isurugimhan.com">contact@isurugimhan.com</a>.<br />
      Isuru Gimhan · Kalutara, Sri Lanka.
    </p>
  </LegalLayout>
);

export default Privacy;
